import { useEffect, useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { Loading } from "../../../../_metronic/elements/Loading";
import { useErrorHandler } from "../../../../_metronic/helpers/ErrorHandler";
import * as UserService from "../services/UserService";

const ViewAccountInformation = () => {
    const { t } = useTranslation();
    const [ userData, setUserData ] = useState(null);
    const [ loading, setLoading ] = useState(false);
    const { errorHandler } = useErrorHandler();
    const load = useCallback(async () => {
        setLoading(true);
        const res = await errorHandler(UserService.me());
        if (res.ok) { 
            setUserData(res.data.data);
        }
        setLoading(false);
    }, []);

    useEffect(() => {
        load();
    }, []);

    const isLoading = loading || userData == null;
    const fields = userData ? [
        [t("account:view.fields.name"), userData.first_name],
        [t("account:view.fields.last_name"), userData.last_name],
        [t("account:view.fields.email"), userData.email],
        [t("account:view.fields.company"), userData.company?.name],
        [t("account:view.fields.phone"), userData.phone],
        [t("account:view.fields.state"), userData.province],
        [t("account:view.fields.city"), userData.city],
        [t("account:view.fields.address"), userData.address],
        [t("account:view.fields.zip"), userData.zip_code],
    ] : [];

    return (
        <section className="specific-account-panel">
            <div className="specific-account-panel__header">
                <div>
                    <h3 className="specific-account-panel__title">{t("account:view.title")}</h3>
                </div>
                <Link to="/user/update" className="btn btn-primary specific-account-primary-action">
                    {t("account:view.update_button")}
                </Link>
            </div>
            {isLoading ? (
                <div className="specific-account-panel__loading">
                    <Loading />
                </div>
            ) : (
                <div className="specific-account-profile">
                    <dl className="specific-account-info-list">
                        {fields.map(([label, value]) => (
                            <div className="specific-account-info-list__row" key={label}>
                                <dt>{label.replace(":", "")}</dt>
                                <dd>{value || "-"}</dd>
                            </div>
                        ))}
                    </dl>
                </div>
            )}
        </section>
    );
};

export default ViewAccountInformation;
